<template>
    <div class="page">

        <div class="weui-tab">
            <div class="weui-navbar2">
                <div v-for="(item, index) in tabs" :key="index" @click="clickThis(index)"
                    :class="['weui-navbar__item2', activeIndex === index ? 'weui-bar__item_on2' : '']">
                    {{ item }}
                </div>
            </div>
        </div>

        <div class="weui-tab__panel tab0" v-if="activeIndex === 0">


            <template v-for="(item, index) in cardList" :key="index" >

                <t-cell @click="choseThisCard(item)"
                    :title="item.cardName"
                    :description="`${item.product?.name} ${item.cardCount}次  有效期：${item.expireDate}天`"
                    :note="`￥${item.totalPrice}`"       hover arrow ></t-cell>

            </template>

        </div>

        <div class="weui-tab__panel tab1" v-if="activeIndex === 1">
   

            <template v-for="(item, index) in cardList2" :key="index">

                <t-cell  @click="choseThisCard(item)"
                hover arrow 
                    :title="item.cardName"
                    :description="`${item.discount}折  有效期：${item.expireDate}天`"
                    :note="`￥${item.totalPrice}`"  ></t-cell>

            </template>
        </div>

        <div class="footBar">
            <t-button class="footBtn" theme="primary" @click="colseDialog">取消</t-button>
        </div>

    </div>
</template>

<script setup>
import { ref, getCurrentInstance, defineEmits, onMounted } from 'vue'



import { stateShop } from '@/store';
// 定义 props

const { proxy } = getCurrentInstance();
const app = proxy.$cloudbase;

// 定义 emits
const emit = defineEmits(['choseCard', 'closeDialog'])

const tabs = ref(['次卡', '打折卡']);
// 响应式数据
const activeIndex = ref(0);


const cardList = ref([]);



const cardList2 = ref([]);



const colseDialog = () => {
    emit('closeDialog')
}

const loadCikaList = async () => {

    const db = app.database();

    let shopId = stateShop._id;
    let queryData = {
        deleted: 0,
        type: 6,
        shopId
    };

    db.collection("my_active").where(queryData).orderBy('createAt.timeStamp', 'desc').get().then(res => {
        cardList.value = res.data;
    })
};

const loadDiscountCardList = () => {
    const db = app.database();
    let shopId = stateShop._id;
    let queryData = {
        deleted: 0,
        type: 7,
        shopId
    };
    db.collection("my_active").where(queryData).orderBy('createAt.timeStamp', 'desc').get().then(res => {
        cardList2.value = res.data;
    })
};

// 方法
const clickThis = (index) => {
    activeIndex.value = index
}



const choseThisCard = (card) => {


    emit('choseCard', card)
}

onMounted(() => {
    loadCikaList();
    loadDiscountCardList();
})
</script>

<style scoped>
.page {
    height: 70vh;
    padding-bottom: 60px;
    background-color: #f6f6f6;
}



.weui-tab__content {
    padding-top: 60px;
    text-align: center;
}

.weui-navbar2 {

    display: flex;
    justify-content: space-around;
}

.weui-navbar__item2 {

    color: gray;
    height: 18px;
    line-height: 18px;
    padding: 12px 15px;
    font-size: 14px;
    position: relative;

}

.weui-bar__item_on2 {

    color: rgb(83, 83, 83);
}

.weui-tab__panel {



    padding: 3vw 4vw;
    box-sizing: border-box;


}

.weui-bar__item_on2:after {
    content: "";

    position: absolute;

    bottom: 0;

    left: 35%;

    width: 30%;

    border: 2px solid rgb(83, 83, 83);
    border-radius: 1px;

    -webkit-transform: scaleY(0.5);

    transform: scaleY(0.5);

    -webkit-transform-origin: 0 0;

    transform-origin: 0 0;

    box-sizing: border-box;

}

.footBar {
    position: fixed;
    bottom: 5vw;
    right: 5vw;
    width: 100vw;
    display: flex;
    justify-content: end;
}

/* 保留原有的样式类名 */
</style>